import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { createLogger } from "logging";
import { PatchWorkingDocumentModel } from "models/PatchWorkingDocumentModel";
import { SiveActionResult } from "models/SiveActionResult";
import { WorkingDocumentModel } from "models/WorkingDocumentModel";

const logger = createLogger("WorkingDocumentsApi");

export class WorkingDocumentsApi {
  constructor(private axios: AxiosInstance) {}

  async getByMeeting(meetingId: number) {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`workingDocuments/meeting/${meetingId}`);
    const response = await this.axios.get<WorkingDocumentModel[]>(url);
    return response.data;
  }

  async update(patch: PatchWorkingDocumentModel) {
    const { id: documentId } = patch;
    if (!documentId) throw new Error("documentId is required");
    const url = getBoardApiUrl(`workingDocuments/${documentId}`);
    logger.debug("update():", documentId, patch);
    const response = await this.axios.patch<SiveActionResult>(url, patch);
    return response.data;
  }

  async uploadMeetingFile(meetingId: number, formData: FormData) {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`workingDocuments/meeting/${meetingId}/upload`);
    logger.debug("uploadMeetingFile():", url, formData);
    const response = await this.axios.post<SiveActionResult>(url, formData);
    return response.data;
  }

  async uploadAgendaItemFile(agendaItemId: number, formData: FormData) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    const url = getBoardApiUrl(`workingDocuments/agendaItem/${agendaItemId}/upload`);
    logger.debug("uploadAgendaItemFile():", url, formData);
    const response = await this.axios.post<SiveActionResult>(url, formData);
    return response.data;
  }

  async delete(documentId: number) {
    if (!documentId) throw new Error("documentId is required");
    const url = getBoardApiUrl(`workingDocuments/${documentId}`);
    const response = await this.axios.delete<SiveActionResult>(url);
    return response.data;
  }
}
